<template>
	<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle cx="10" cy="10" r="10"/><path d="M8.986 8c.24 0 .481.025.719.073.66.135 1.173.513 1.44 1.062.327.672.261 1.531-.184 2.42l-.75 1.495c-.4.798-.166.962-.04 1.05.025.018.105.06.304.06.36 0 .775-.139.78-.14a.376.376 0 0 1 .368.637 3.818 3.818 0 0 1-2.361.844c-.239 0-.48-.026-.716-.073-.662-.135-1.174-.512-1.44-1.062-.328-.671-.263-1.53.183-2.419l.75-1.496c.4-.797.165-.963.038-1.052-.024-.017-.104-.058-.301-.058-.36 0-.776.139-.78.14a.375.375 0 0 1-.37-.636 3.814 3.814 0 0 1 2.36-.844Zm1.64-4.499a1.875 1.875 0 1 1 0 3.75 1.875 1.875 0 0 1 0-3.75Z"  fill-rule="nonzero"/></g></svg>
</template>
<style scoped lang="scss">
circle {
	fill: currentColor;
}
path {
	fill: $white;
}
</style>
